module.exports = __webpack_public_path__ + "assets/img/2021-8-active.3e612b60.png";